/**
 * Returns all indices in the `ids` array that match the given `uwi`.
 * Used by the XDA hover handler to find all cross-section shapes belonging
 * to the same well (e.g., a U-shape well with multiple intercepts).
 */
export function getMatchingUwiIndices(ids: readonly string[], uwi: string): number[] {
  const result: number[] = [];
  for (let i = 0; i < ids.length; i++) {
    if (ids[i] === uwi) {
      result.push(i);
    }
  }
  return result;
}
